import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ReportBox from "../atoms/ComponentBox/ReportBox";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const PaymentLogs = () => {
    const permissions = useSelector(selectPermissions);
    const hasModulePermission = (moduleName) => {
        const modulePermission = permissions.find(
            permission => permission.ModuleName === moduleName
        );

        if (!modulePermission) return false;

        return (
            modulePermission.AddRec === "1" ||
            modulePermission.EditRec === "1" ||
            modulePermission.DeleteRec === "1" ||
            modulePermission.ViewRec === "1"
        );
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    {hasModulePermission("Payment Request Log") && (
                        <ReportBox
                            totalCount={10}
                            activeCount={10}
                            inactiveCount={0}
                            permissions={permissions}
                            link={{ pathname: "/paymentreqlog" }}
                            title="Payment Request Log"
                        />
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}

export default PaymentLogs;
